import './AccountMenu.css';
import React, { useEffect, useRef, useState } from 'react';
import Settings from 'lucide-react/dist/esm/icons/settings';
import KeyRound from 'lucide-react/dist/esm/icons/key-round';
import ShieldCheck from 'lucide-react/dist/esm/icons/shield-check';
import LogOut from 'lucide-react/dist/esm/icons/log-out';
import ChevronsUpDown from 'lucide-react/dist/esm/icons/chevrons-up-down';
import CreditCard from 'lucide-react/dist/esm/icons/credit-card';

export default function AccountMenu({ user, isAdmin, onOpenProfile, onOpenAccount, onOpenUsers, onOpenSubscription, onLogout }) {
  const [open, setOpen] = useState(false);
  const container = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    container.current?.querySelector('.sidebar-account-popover button')?.focus();
    const dismiss = (event) => {
      if (!container.current?.contains(event.target)) setOpen(false);
    };
    const escape = (event) => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    document.addEventListener('pointerdown', dismiss);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('pointerdown', dismiss);
      document.removeEventListener('keydown', escape);
    };
  }, [open]);
  const choose = (action) => { setOpen(false); action?.(); };
  const role = user?.is_platform_access ? 'Superuser' : user?.role;
  return <div className="sidebar-account" ref={container}>
    {open && <div id="sidebar-account-actions" className="sidebar-account-popover" aria-label="Account actions">
      <div className="sidebar-account-details"><strong>{user.email}</strong><span>{role}{user.company_name ? ` · ${user.company_name}` : ''}</span></div>
      <button type="button" onClick={() => choose(onOpenProfile)}><Settings size={17} />User settings</button>
      <button type="button" data-prefetch="/account" onClick={() => choose(onOpenAccount)}><KeyRound size={17} />My ChatGPT account</button>
      {isAdmin && <button type="button" onClick={() => choose(onOpenUsers)}><ShieldCheck size={17} />User access management</button>}
      {onOpenSubscription && <button type="button" data-prefetch="/subscription" onClick={() => choose(onOpenSubscription)}><CreditCard size={17} />Subscription</button>}
      <button type="button" className="sidebar-account-logout" onClick={() => choose(onLogout)}><LogOut size={17} />Log out</button>
    </div>}
    <button type="button" ref={trigger} className="sidebar-account-trigger" disabled={!user}
      aria-label="Account options" aria-expanded={open} aria-controls="sidebar-account-actions"
      onClick={() => setOpen(value => !value)}>
      <span className="sidebar-account-avatar" aria-hidden="true">{user?.email?.trim().charAt(0).toUpperCase() || '?'}</span>
      <span className="sidebar-account-identity"><strong>{user?.email || 'Loading account…'}</strong><small>{role || 'Workspace account'}</small></span>
      <ChevronsUpDown size={16} />
    </button>
  </div>;
}
